import React, { Component } from "react";
import { shape } from "prop-types";
import { connect } from "react-redux";

import { selectors as debinSelectors } from "reducers/debin";

import moment from "moment";
import { Col } from "react-bootstrap";
import Heading from "pages/_components/Heading";
import FormattedDate from "pages/_components/FormattedDate";
import * as i18nUtils from "util/i18n";
import * as configUtils from "util/config";
import { isFinalState } from "util/transaction";

const FORM_ID = "debin.recurrency";

class RecurrencyTransactionData extends Component {
    static propTypes = {
        recurrencyAction: shape({}).isRequired,
    };

    dateTimeCreationIsDifferentFromModify = (creation, modification) => {
        const creation_ = moment(creation);
        const modification_ = moment(modification);
        return modification_.diff(creation_, "seconds") > 1;
    };

    render() {
        const { recurrencyAction } = this.props;
        return (
            recurrencyAction?.idTransaction && (
                <>
                    {isFinalState(recurrencyAction.idTransactionStatus) && (
                        <Col xs={12} className="px-0">
                            <Heading.DataGroup
                                containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                                labelClassName="data-label-medium"
                                dataClassName="data-desc"
                                label="negotiate.transaction.date.label"
                                data={
                                    <p className="data-desc m-0">
                                        <FormattedDate
                                            date={recurrencyAction.submitDateTime}
                                            dateFormat="dd/MM/yyyy"
                                            showTime
                                        />
                                    </p>
                                }
                            />
                        </Col>
                    )}
                    <Col xs={12} className="px-0">
                        <Heading.DataGroup
                            containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                            labelClassName="data-label-medium"
                            dataClassName="data-desc"
                            label="payments.debin.detail.table.header.voucher"
                            data={
                                <p className="data-desc m-0">
                                    {recurrencyAction?.idTransaction.substring(0, 8).toUpperCase()}
                                </p>
                            }
                        />
                    </Col>
                    <Col xs={12} className="px-0">
                        <Heading.DataGroup
                            containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                            labelClassName="data-label-medium"
                            dataClassName="data-desc"
                            label={`${FORM_ID}.account.title`}
                            data={<p className="data-desc m-0">{recurrencyAction?.accountFull}</p>}
                        />
                    </Col>
                    <Col xs={12} className="px-0">
                        <Heading.DataGroup
                            containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                            labelClassName="data-label-medium"
                            dataClassName="data-desc"
                            label={`${FORM_ID}.seller.name.title`}
                            data={<p className="data-desc m-0">{recurrencyAction?.sellerInfo?.titular}</p>}
                        />
                    </Col>
                    <Col xs={12} className="px-0">
                        <Heading.DataGroup
                            containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                            labelClassName="data-label-medium"
                            dataClassName="data-desc"
                            label={`${FORM_ID}.seller.cuit.title`}
                            data={<p className="data-desc m-0">{recurrencyAction?.seller}</p>}
                        />
                    </Col>
                    {recurrencyAction.limite_cuotas && (
                        <Col xs={12} className="px-0">
                            <Heading.DataGroup
                                containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                                labelClassName="data-label-medium"
                                dataClassName="data-desc"
                                label="debin.programmed.transaction.installments.title"
                                data={<p className="data-desc m-0">{recurrencyAction?.limite_cuotas}</p>}
                            />
                        </Col>
                    )}
                    <Col xs={12} className="px-0">
                        <Heading.DataGroup
                            containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                            labelClassName="data-label-medium"
                            dataClassName="data-desc"
                            label={`${FORM_ID}.prestacion.title`}
                            data={<p className="data-desc m-0">{recurrencyAction?.prestacion}</p>}
                        />
                    </Col>
                    <Col xs={12} className="px-0">
                        <Heading.DataGroup
                            containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                            labelClassName="data-label-medium"
                            dataClassName="data-desc"
                            label={`${FORM_ID}.concept.title`}
                            data={
                                <p className="data-desc m-0">
                                    {recurrencyAction?.concepto} -{" "}
                                    {i18nUtils.get(`transfers.concept.${recurrencyAction?.concepto}`)}
                                </p>
                            }
                        />
                    </Col>
                    <Col xs={12} className="px-0">
                        <Heading.DataGroup
                            containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                            labelClassName="data-label-medium"
                            dataClassName="data-desc"
                            label={`${FORM_ID}.reference.title`}
                            data={<p className="data-desc m-0">{recurrencyAction?.detalle}</p>}
                        />
                    </Col>
                    <Col xs={12} className="px-0">
                        <Heading.DataGroup
                            containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                            labelClassName="data-label-medium"
                            dataClassName="data-desc"
                            label={`${FORM_ID}.descripcion.title`}
                            data={<p className="data-desc m-0">{recurrencyAction?.referencia}</p>}
                        />
                    </Col>
                    {recurrencyAction.idTransactionStatus === "FAILED" &&
                        !configUtils.getBoolean("frontend.show.failedVoucher.payFunctionalities") && (
                            <>
                                <Col xs={12} className="px-0">
                                    <Heading.DataGroup
                                        containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                                        labelClassName="data-label-medium"
                                        dataClassName="data-desc"
                                        label={`${FORM_ID}.coelsa.response`}
                                        data={<p className="data-desc m-0">{recurrencyAction?.coelsaResponse}</p>}
                                    />
                                </Col>
                                <Col xs={12} className="px-0">
                                    <Heading.DataGroup
                                        containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                                        labelClassName="data-label-medium"
                                        dataClassName="data-desc"
                                        label={`${FORM_ID}.coelsa.code`}
                                        data={<p className="data-desc m-0">{recurrencyAction?.coelsaCode}</p>}
                                    />
                                </Col>
                            </>
                        )}
                </>
            )
        );
    }
}

const mapStateToProps = (state) => ({
    recurrencyAction: debinSelectors.getRecurrencyDebinAction(state),
});

export default connect(mapStateToProps)(RecurrencyTransactionData);
